import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Users, MapPin, ShieldCheck, CreditCard, Lock } from 'lucide-react';
export function Hero() {
  return <section className="bg-navy text-white pt-6 pb-10 md:pt-12 md:pb-20 px-4 relative overflow-hidden" data-id="element-177">
      <div className="max-w-6xl mx-auto" data-id="element-178">
        <div className="flex flex-col items-center text-center mb-6 md:mb-12" data-id="element-179">
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full text-sm font-semibold mb-4 md:mb-6" data-id="element-180">
            <span className="text-[12px]" data-id="element-181">⚽ FÚTBOL FEMENINO™</span>
            <span className="text-brandGreen" data-id="element-182">•</span>
            <span className="text-gray-300" data-id="element-183">recursosfitness.shop</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-6xl lg:text-7xl font-black leading-tight mb-4 md:mb-6" data-id="element-184">
            Todo tu año de Fútbol Femenino{' '}
            <span className="text-brandGreen" data-id="element-185">resuelto.</span>
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.15,
          duration: 0.6
        }} className="w-full max-w-[700px] mx-auto mb-4 md:mb-6 px-4" data-id="element-186">
            <img src="https://cdn.magicpatterns.com/uploads/pAf4LFX5wertLsnNu5z6go/Diseno_sin_titulo-65.png" alt="Megapack Fútbol Femenino Resuelto" className="w-full h-auto" data-id="element-187" />
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="md:text-2xl font-bold text-yellow-400 mb-4 md:mb-6 text-[14px]" data-id="element-188">
            6 Tomos · +60 Sesiones · 6 Bonos · Listo para usar.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto mb-6 md:mb-8 leading-relaxed" data-id="element-189">
            Tu temporada completa resuelta: sesiones, táctica, planificación,
            fisiología femenina, liderazgo y gestión de equipo. Sin improvisar.
            Sin buscar en Google. Sin perder noches armando lo que ya está
            hecho.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="inline-flex items-center justify-center divide-x divide-white/15 bg-white/5 rounded-full px-1 py-1 mb-6 md:mb-10" data-id="element-190">
            {[{
            icon: FileText,
            label: 'PDF digital'
          }, {
            icon: Zap,
            label: 'Inmediato'
          }, {
            icon: Users,
            label: 'Todos los niveles'
          }, {
            icon: MapPin,
            label: 'Argentina 🇦🇷'
          }].map((item, i) => <span key={i} className="flex items-center gap-1.5 px-3 py-1 md:px-4 md:py-1.5 text-[11px] md:text-xs font-medium text-gray-300" data-id="element-191">
                <item.icon className="w-3 h-3 text-brandGreen flex-shrink-0" data-id="element-192" />
                {item.label}
              </span>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="w-full max-w-md mx-auto" data-id="element-193">
            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full bg-brandGreen hover:bg-brandGreen-hover text-navy font-black text-base md:text-xl py-4 md:py-5 px-6 md:px-8 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.4)] transition-all transform hover:scale-105 active:scale-95 flex items-center justify-center gap-2" data-id="element-194">
              💥 QUIERO MI FÚTBOL FEMENINO RESUELTO AHORA
            </button>

            <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 mt-3 md:mt-4 text-xs md:text-sm text-gray-400" data-id="element-195">
              <span className="flex items-center gap-1" data-id="element-196">
                <ShieldCheck className="w-3 h-3 md:w-4 md:h-4" data-id="element-197" /> Garantía 7
                días
              </span>
              <span className="flex items-center gap-1" data-id="element-198">
                <Lock className="w-3 h-3 md:w-4 md:h-4" data-id="element-199" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-200">
                <CreditCard className="w-3 h-3 md:w-4 md:h-4" data-id="element-201" /> Mercado Pago |
                Tarjeta
              </span>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="relative max-w-5xl mx-auto mt-6 md:mt-12" data-id="element-202">
          <div className="absolute inset-0 bg-brandGreen/20 blur-[100px] rounded-full" data-id="element-203"></div>
        </motion.div>
      </div>
    </section>;
}